export default __webpack_public_path__ + "static/media/user.7e97c90f.png";